import { GraviButton, Horizontal, MaterialIcon, Vertical } from '@gravitate-js/excalibrr'
import { Card, Popconfirm, Tooltip } from 'antd'
import type { MatchDetailRow } from './MatchDetailPane'
import { TitleLabel } from '@/components/_SiteWide/TitleLabel'

import { formatCurrency } from '@/utils/formatters'
import { formatters } from '@/utils/intl/dateTimeFormatters'

type BOLCardProps = {
  bol: MatchDetailRow
  handleUnmatch: ((item: MatchDetailRow) => void) | null
}

export function BOLCard({ bol, handleUnmatch }: BOLCardProps) {
  return (
    <Card
      key={bol.document_id}
      size='small'
      style={{
        borderRadius: 6,
      }}
      styles={{ body: { padding: 12 } }}
    >
      <Vertical gap={8}>
        <Horizontal justifyContent='space-between'>
          <TitleLabel title='BOL #'>{bol.document_number}</TitleLabel>
          <TitleLabel title='Total' align='right'>
            {formatCurrency(bol.total)}
          </TitleLabel>
        </Horizontal>
        <Horizontal justifyContent='space-between'>
          <TitleLabel title='Supplier'>
            {bol.supplier?.internal_name?.toString() ?? bol.supplier?.source_name?.toString()}
          </TitleLabel>
          <TitleLabel title='BOL Date' align='right'>
            {formatters.DATE_TIME(bol.document_date, bol.timezone_data?.terminal?.toString())}
          </TitleLabel>
        </Horizontal>
        <TitleLabel title='BOL Carrier'>{bol.carrier}</TitleLabel>
        <TitleLabel title='Destination'>{`${bol.store_number}, ${bol.site_name}`}</TitleLabel>
        <Horizontal>
          {handleUnmatch && (
            <Tooltip title='Unmatch'>
              <Popconfirm
                title='Unmatch'
                description='Are you sure you want to unmatch?'
                onConfirm={() => handleUnmatch(bol)}
                okText='Yes, Unmatch'
                cancelText='Cancel'
              >
                <GraviButton size='small' icon={<MaterialIcon className='pt-1' icon='link_off' />} type='text'>
                  Unmatch
                </GraviButton>
              </Popconfirm>
            </Tooltip>
          )}
        </Horizontal>
      </Vertical>
    </Card>
  )
}
